var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import get from 'lodash.get';
import { getCurrentSenior, getLocalStorage } from 'globals/global.functions';
import { API } from 'globals/api';
import { showApplicationLoader, hideApplicationLoader, } from 'common/ApplicationLoader';
import { showToast } from 'common/Toast';
import { API_DATA_LIMIT } from 'globals/global.constants';
import { postUserMappingService } from 'services/userService/userService';
export var getCallLogs = function (filters) {
    var seniorInfo = __assign({}, getCurrentSenior());
    return function (dispatch, getState) {
        var _a;
        var cacheData = getLocalStorage('callLogs');
        var params;
        if (cacheData) {
            params = {
                user_id: seniorInfo.seniorID,
                call_status: 'completed',
                limit: API_DATA_LIMIT,
                last_evaluated_key: cacheData.lastEvaluatedKey,
            };
        }
        else {
            params = {
                user_id: seniorInfo.seniorID,
                call_status: 'completed',
                limit: API_DATA_LIMIT,
            };
        }
        if ((filters === null || filters === void 0 ? void 0 : filters.callDirection) && filters.callDirection !== 'All') {
            params.call_direction = filters.callDirection.toLowerCase();
        }
        if (((_a = filters === null || filters === void 0 ? void 0 : filters.callType) === null || _a === void 0 ? void 0 : _a.length) && !filters.callType.includes('All')) {
            params.call_type = filters.callType.map(function (callType) { return callType.toLowerCase(); });
        }
        if (filters === null || filters === void 0 ? void 0 : filters.startDate) {
            params.start_date = filters.startDate;
        }
        if (filters === null || filters === void 0 ? void 0 : filters.endDate) {
            params.end_date = filters.endDate;
        }
        return API({
            url: "supervision/senior-calls",
            method: 'get',
            params: params,
        })
            .then(function (res) {
            var logList = get(res, 'data.data');
            var lastEvaluatedKey = res.data.last_evaluated_key;
            var careagent_ids = [];
            logList.map(function (data) {
                careagent_ids.push(data.careagent_id);
            });
            var userList = postUserMappingService(__spreadArray([getState().auth.userId], careagent_ids, true)).then(function (result) {
                return result;
            });
            return Promise.all([userList]).then(function (response) {
                var careagent = response[0];
                logList.map(function (logListData) {
                    var firstName = get(careagent, "".concat(logListData['careagent_id'], ".name.first_name"), '');
                    var lastName = get(careagent, "".concat(logListData['careagent_id'], ".name.last_name"), '');
                    logListData['careagent_name'] = [firstName, lastName]
                        .filter(Boolean)
                        .join(' ');
                });
                return {
                    data: logList,
                    lastEvaluatedKey: lastEvaluatedKey,
                };
            });
        })
            .catch(function (err) {
            var message = get(err, 'response.data.message');
            dispatch(showToast(message, 'error'));
            return [];
        });
    };
};
export var fetchCallNotes = function (account_id, senior_id, call_id) {
    return function (dispatch) {
        dispatch(showApplicationLoader());
        return API({
            url: "supervision/call-logs/detail",
            method: 'get',
            params: {
                account_id: account_id,
                senior_id: senior_id,
                call_id: call_id,
            },
        })
            .then(function (res) {
            dispatch(hideApplicationLoader());
            return get(res, 'data');
        })
            .catch(function () {
            dispatch(hideApplicationLoader());
        });
    };
};
export var updateCallNotes = function (callInfo, data) {
    return function (dispatch) {
        dispatch(showApplicationLoader());
        return API({
            url: "supervision/call-logs",
            method: 'put',
            data: {
                account_id: callInfo.account_id,
                senior_id: callInfo.senior_id,
                call_id: callInfo.call_id,
                care_call_notes: data.callNotes,
                action_item: data.actionItems,
                situation: data.situation,
                background: data.background,
                assessment: data.assessment,
                recommendation: data.recommendation,
            },
        })
            .then(function () {
            dispatch(hideApplicationLoader());
            dispatch(showToast('Call Updated Successfully!', 'success'));
        })
            .catch(function () {
            dispatch(hideApplicationLoader());
            dispatch(showToast('Something Went Wrong!', 'error'));
        });
    };
};
